import React, { useState } from 'react';
import DefaultModal from 'components/Utils/DefaultModal';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PatientUtils from 'services/PatientUtils';
import { Patient } from 'generated/api';
import Icon from '../../Utils/NewIcon';
import './notes.scss';

interface NotesBadgeProps {
  notes?: string;
  patient?: Patient;
  notesModalOpen: boolean;
  setNotesModalOpen: (open: boolean) => void;
  onNotesChanged: (notes: string) => Promise<void>;
}

const NotesBadge: React.FC<NotesBadgeProps> = ({
  patient,
  notes,
  onNotesChanged,
  notesModalOpen,
  setNotesModalOpen,
}) => {
  if (!patient) return null;

  return (
    <>
      <div className={`notes-badge ${!!notes ? 'has-notes' : 'empty'}`}>
        <Icon src="sticky-note" height="12px" />
      </div>

      {notesModalOpen && (
        <NotesEditorModal
          isOpen={notesModalOpen}
          onClose={() => setNotesModalOpen(false)}
          initialNotes={notes}
          onNotesChanged={onNotesChanged}
          patient={patient}
        />
      )}
    </>
  );
};

interface NotesEditorModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialNotes?: string;
  onNotesChanged: (notes: string) => Promise<void>;
  patient: Patient;
}

const NotesEditorModal: React.FC<NotesEditorModalProps> = ({
  isOpen,
  onClose,
  initialNotes,
  onNotesChanged,
  patient,
}) => {
  const [notes, setNotes] = useState(initialNotes || '');

  const patientName = PatientUtils.getName(patient, undefined, true, false);

  const modalContent = (
    <div className="notes-editor-modal">
      <div className="notes-editor-content">
        <textarea
          className="notes-textarea"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Add notes for this bubble..."
          rows={10}
          autoFocus
        />
        <div className="notes-hint">Tip: Use dashes or numbers for lists</div>
      </div>
      <div className="notes-editor-footer">
        <DefaultButton
          name="Save"
          className="blue full-width"
          onClick={async () => {
            onClose();
            await onNotesChanged(notes);
          }}
        />
      </div>
    </div>
  );

  return (
    <DefaultModal
      title={
        <div>
          <span>Notes: {patientName}</span>
        </div>
      }
      content={modalContent}
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnEsc={true}
      className="notes-editor-modal-wrapper fit-modal"
      wrap={true}
    />
  );
};

export default NotesBadge;
